import { produce } from 'immer';
import { TGroupStateKeys, IGroupState, EGroupStateKeys } from '../../domain/group.interface';
import {
  GROUPLIST_LOADED,
  GROUP_COMPLETE_LOADED,
  GROUP_INFO_LOADED,
  GROUP_MEMBERS_LOADED,
  GROUP_WISHES_LOADED,
  GROUP_MONEYBOX_LOADED,
  GROUP_RESET,
} from './grouplist.actions';

export const initialState: IGroupState = {
  [EGroupStateKeys.groupList]: [],
  [EGroupStateKeys.groupComplete]: {},
  [EGroupStateKeys.groupInfo]: {},
  [EGroupStateKeys.groupMembers]: [],
  [EGroupStateKeys.groupWishes]: [],
  [EGroupStateKeys.groupMoneybox]: {},
};

export const groupListReducer = (state = initialState, action: any) =>
  produce(state, draft => {
    switch (action.type) {
      case GROUPLIST_LOADED:
        draft.groupList = action.payload;
        return;
      case GROUP_COMPLETE_LOADED:
        draft.groupComplete = action.payload;
        return;
      case GROUP_INFO_LOADED:
        draft.groupInfo = action.payload;
        return;
      case GROUP_MEMBERS_LOADED:
        draft.groupMembers = action.payload;
        return;
      case GROUP_WISHES_LOADED:
        draft.groupWishes = action.payload;
        return;
      case GROUP_MONEYBOX_LOADED:
        draft.groupMoneybox = action.payload;
        return;
      case GROUP_RESET:
        draft[action.payload as TGroupStateKeys] = initialState[action.payload as TGroupStateKeys];
        return;
    }
  });
